import { render, staticRenderFns } from "./HostInvitationDialog.vue?vue&type=template&id=1b7bceda&scoped=true&"
import script from "./HostInvitationDialog.vue?vue&type=script&lang=ts&"
export * from "./HostInvitationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./HostInvitationDialog.vue?vue&type=style&index=0&id=1b7bceda&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7bceda",
  null
  
)

export default component.exports